import { Component, inject, input, InputSignal } from '@angular/core';
import { Router } from '@angular/router';
import { DeliveriesService } from '../../../settings/account/deliveries/deliveries.service';
import { formatDateToReadableString } from '../../utils/formatting';

@Component({
  selector: 'app-missed-order-info',
  imports: [],
  templateUrl: './missed-order-info.component.html',
  styleUrl: './missed-order-info.component.scss'
})
export class MissedOrderInfoComponent {
  
  private router = inject(Router);
  private deliveriesService = inject(DeliveriesService);

  product: InputSignal<any> = input.required();

  getCurrentOrderDeliveryDate(): string {
    const deliveryInfo = this.deliveriesService.deliveryZoneInfo();
    if (!deliveryInfo) return '';

    const currentDeliveryInfo = deliveryInfo.order || deliveryInfo;
    const deliveryDate = (currentDeliveryInfo as any).deliveryDate;
    if (!deliveryDate) return '';

    const deliveryDateFormatted = formatDateToReadableString(deliveryDate);
    
    return `${deliveryDateFormatted.dayName} ${deliveryDateFormatted.month} ${deliveryDateFormatted.day}`;
  }

  navigateToSubscriptionManagement() {
    this.router.navigate(['/settings/account/subscriptions']);
  }

}
